import React from 'react'
import { InternalIconProps } from '../Icon.types'

const Phone = ({
  colors: { primary, secondary },
  ...props
}: InternalIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={primary}
      fillRule="evenodd"
      d="M24.983 29.157c.653-.6 1.02-1.44 1.016-2.317v-3.321c.034-1.583-1.131-2.956-2.736-3.182-.998-.133-1.97-.375-2.905-.725-1.176-.443-2.506-.159-3.393.72l-.865.867c-2.144-1.354-3.957-3.18-5.3-5.34l.912-.914c.864-.876 1.137-2.158.71-3.296-.35-.943-.595-1.926-.727-2.926C11.474 7.154 10.116 5.984 8.504 6H5.187c-.907.001-1.766.381-2.369 1.043-.593.651-.884 1.516-.805 2.386.38 3.588 1.594 7.024 3.546 10.043 1.771 2.794 4.143 5.17 6.942 6.952 3.002 1.952 6.43 3.174 10 3.562.924.084 1.82-.22 2.482-.829zm-1.995-6.987c.613.087 1.087.648 1.07 1.339v3.334c.002.379-.153.734-.421.98-.258.237-.596.352-.934.321-3.238-.353-6.367-1.468-9.118-3.256-2.568-1.635-4.74-3.812-6.37-6.382-1.802-2.787-2.92-5.954-3.27-9.25-.032-.36.092-.727.338-.998.237-.26.565-.405.905-.405h3.326c.625-.007 1.165.459 1.256 1.109.149 1.125.425 2.238.824 3.31.183.488.066 1.037-.291 1.4l-1.405 1.407c-.29.29-.35.727-.15 1.08 1.661 2.928 4.083 5.355 7.01 7.023.39.221.888.156 1.2-.157l1.409-1.411c.34-.338.839-.445 1.281-.278 1.08.404 2.2.683 3.34.834z"
      clipRule="evenodd"
    />
    <path
      fill={secondary}
      fillRule="evenodd"
      d="M17.376 8c-.386-.003-.771.04-1.147.129-.538.126-1.076-.207-1.202-.745-.127-.538.207-1.076.745-1.202.53-.125 1.072-.186 1.616-.182 1.845.001 3.615.735 4.92 2.04 1.307 1.306 2.04 3.077 2.04 4.924.002.706-.107 1.408-.32 2.081-.168.527-.73.818-1.257.65-.526-.167-.817-.73-.65-1.256.152-.476.228-.973.228-1.473v-.001c0-1.317-.523-2.58-1.454-3.51C19.964 8.522 18.7 8 17.384 8h-.008zm6.973 4.964h-1 1z"
      clipRule="evenodd"
    />
    <path
      fill={secondary}
      fillRule="evenodd"
      d="M17.776 1h.005c1.562.002 3.107.311 4.55.91 1.442.6 2.752 1.477 3.855 2.582 1.103 1.106 1.977 2.417 2.573 3.86.596 1.443.902 2.99.9 4.55.005 1.198-.176 2.39-.535 3.534-.165.527-.726.82-1.253.654-.527-.165-.82-.726-.655-1.253.298-.948.447-1.936.443-2.93v-.005c.002-1.299-.253-2.585-.748-3.786-.496-1.2-1.224-2.292-2.141-3.211-.918-.92-2.007-1.65-3.207-2.148-1.199-.498-2.484-.755-3.782-.757-.854.003-1.704.113-2.531.326-.535.138-1.08-.184-1.218-.718-.138-.535.184-1.08.719-1.218.988-.255 2.004-.386 3.025-.39z"
      clipRule="evenodd"
    />
  </svg>
)

export default Phone
